import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import classNames from 'classnames';
const STYLE = {
    WHITE: 'white',
    GRAY: 'gray',
};
export const LoadMoreProgress = ({ loaded = 0, total = 0, progressBarStyle = STYLE.WHITE }) => {
    if (!loaded || !total) {
        return null;
    }
    const width = `${(loaded / total) * 100}%`;
    const progressClassName = classNames('progress', 'height-2 margin-bottom-10', progressBarStyle === STYLE.GRAY ? 'bg-lighter' : 'bg-white');
    const progressBarClassName = classNames('progress-bar', progressBarStyle === STYLE.GRAY &&
        width !== '100%' &&
        'border border-right-only border-color-white border-width-2');
    return (_jsxs(React.Fragment, { children: [_jsxs("div", Object.assign({ className: 'text-center margin-bottom-3' }, { children: [_jsx("span", Object.assign({ className: 'text-medium' }, { children: loaded })), _jsx("span", Object.assign({ className: 'margin-left-5 margin-right-5' }, { children: "/" })), _jsx("span", Object.assign({ className: 'text-medium' }, { children: total }))] })), _jsx("div", Object.assign({ className: progressClassName }, { children: _jsx("div", { className: progressBarClassName, style: { width } }) }))] }));
};
export default LoadMoreProgress;
